/***************************************************************************************/ 
 /* This file is generated. Do not edit by hand unless you 100% know what you're doing.. */ 
 /***************************************************************************************/ 
 
export enum UnitPropKey { 
    Available = "Available",
    Dimensions = "Dimensions",
    ExternalUnitId = "ExternalUnitId",
    Features = "Features",
    Floor = "Floor",
    FMSType = "FMSType",
    Length = "Length",
    LocationId = "LocationId",
    Number = "Number",
    Rate = "Rate",
    Type = "Type",
    Width = "Width",

}